import React, { Component } from "react";

export default class AttestModalForm2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      connections: [],
    };
  }

  componentDidMount = () => {
    this.handleConnections();
  };

  handleConnections = () => {
    let intersection = [];
    let clientNameList = [];
    // if connection is a client name
    this.props.clients.forEach((client) => {
      if (client.connections) {
        client.connections.forEach((connection) => {
          if (
            connection.toLowerCase() ===
            this.props.data["client-name"].toLowerCase()
          ) {
            clientNameList.push(client);
          }
        });
      }
    });
    // if connection is an ID
    let clientIdName = [];
    this.props.clients.forEach((client) => {
      if (client.connections) {
        client.connections.forEach((connection) => {
          this.props.data.connections.forEach((dataConnection) => {
            if (connection === dataConnection) {
              clientIdName.push(client);
            }
          });
        });
      }
    });
    // remove duplicates
    [...clientNameList, ...clientIdName].forEach((element) => {
      if (intersection.indexOf(element) === -1) {
        intersection.push(element);
      }
    });
    // filter out the client name
    intersection = intersection.filter(
      (i) =>
        i["client-name"] !== this.props.data["client-name"] &&
        i.accounts !== this.props.data.accounts
    );
    this.setState({ connections: intersection });
  };

  render() {
    const {
      accountName,
      groupId,
      submitData,
      data,
      handleDataAccountsCheck,
      prevCurr,
    } = this.props;
    const { connections } = this.state;

    return (
      <div>
        <h5 className="text-start">
          Select the accounts that relate to your previous answers.
        </h5>
        <hr />
        <div>
          <h5 className="text-start">{accountName} Accounts:</h5>
          {submitData["client-name"] &&
            Object.keys(
              data.accounts[
                prevCurr === "Previous Year" ? "Previous" : "Current"
              ]
            ).map((a, index) => (
              <div className="text-start m-2 ms-3" key={index}>
                <h6>{a}:</h6>
                {/* {data.accounts[
                  Object.keys(data.accounts)[
                    // prevCurr === "Previous Year" ? 1 : 0
                  ]
                ][a].length > 1 && (
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      value=""
                      id={`${accountName}${a.type}_CheckAll`}
                      onClick={() => console.log("Check All")}
                    />
                    <label
                      className="form-check-label"
                      htmlFor={`${accountName}${a.type}_CheckAll`}
                    >
                      <strong>Select All</strong>
                    </label>
                  </div>
                )} */}

                <div className="row row-cols-2 row-cols-lg-4 g-1 g-lg-1">
                  {data.accounts[
                    prevCurr === "Previous Year" ? "Previous" : "Current"
                  ][a].map((i, index1) => (
                    <div className="col" key={index1}>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id={`${accountName}${a}FlexCheckDefault${index1}`}
                          onChange={() =>
                            handleDataAccountsCheck(
                              `${accountName}${a}FlexCheckDefault${index1}_${accountName}_${groupId}_${a}_${i.account}`
                            )
                          }
                          checked={
                            submitData.accounts.includes(
                              `${accountName}${a}FlexCheckDefault${index1}_${accountName}_${groupId}_${a}_${i.account}`
                            ) || i.submitted === "true"
                          }
                          disabled={i.submitted === "true"}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`${accountName}${a}FlexCheckDefault${index1}`}
                        >
                          {i.account}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
        </div>
        {connections.length > 0 && (
          <div>
            <h5 className="text-start">See Also:</h5>
            {connections.map((ca, index) => (
              <div key={index}>
                <h6 className="text-start">
                  <u>{ca["client-name"]}</u>:
                </h6>
                {ca["client-name"] &&
                  Object.keys(
                    ca.accounts[
                      prevCurr === "Previous Year" ? "Previous" : "Current"
                    ]
                  ).map((a, index) => (
                    <div className="text-start m-2 ms-3" key={index}>
                      <h6>{a}:</h6>
                      {/* {ca.accounts[
                        Object.keys(ca.accounts)[
                          prevCurr === "Previous Year" ? 1 : 0
                        ]
                      ][a].length > 1 && (
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            value=""
                            id={`${ca["client-name"]}${a.type}_CheckAll`}
                            onClick={() => console.log("Check All")}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`${ca["client-name"]}${a.type}_CheckAll`}
                          >
                            <strong>Select All</strong>
                          </label>
                        </div>
                      )} */}

                      <div className="row row-cols-2 row-cols-lg-4 g-1 g-lg-1">
                        {ca.accounts[
                          prevCurr === "Previous Year"
                            ? "Previous"
                            : "Current"
                        ][a].map((i, index1) => (
                          <div className="col" key={index1}>
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                value=""
                                id={`${ca["client-name"]}${a}FlexCheckDefault${index1}`}
                                onChange={() => {
                                  handleDataAccountsCheck(
                                    `${ca["client-name"]}${a}FlexCheckDefault${index1}_${ca["client-name"]}_${ca["group-id"]}_${a}_${i.account}`
                                  );
                                }}
                                checked={
                                  submitData.accounts.includes(
                                    `${ca["client-name"]}${a}FlexCheckDefault${index1}_${ca["client-name"]}_${ca["group-id"]}_${a}_${i.account}`
                                  ) || i.submitted === "true"
                                }
                                disabled={i.submitted === "true"}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`${ca["client-name"]}${a}FlexCheckDefault${index1}`}
                              >
                                {i.account}
                              </label>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}
